/**
 * Configuración de Netlify Functions
 * Centraliza la URL base para las llamadas a funciones serverless
 * 
 * NOTA: Este archivo mantiene compatibilidad con código existente.
 * La configuración real está en config.js
 */

import config, { getNetlifyFunctionUrl as getUrlFromConfig } from './config';

// URL base para las funciones de Netlify desde config centralizado
const NETLIFY_FUNCTIONS_BASE_URL = config.netlify.baseUrl;

/**
 * Construye la URL completa para una función de Netlify
 * @param {string} functionName - Nombre de la función (sin el prefijo /.netlify/functions/)
 * @returns {string} URL completa de la función
 */
export const getNetlifyFunctionUrl = (functionName) => {
  return getUrlFromConfig(functionName);
};

const netlifyConfig = {
  baseUrl: NETLIFY_FUNCTIONS_BASE_URL,
  getNetlifyFunctionUrl,
};

export default netlifyConfig;
